
const navWrap=document.getElementsByClassName("homeNaviWrap");
const navs=document.getElementsByTagName("nav");
const navHeight=navs[0].offsetHeight;
navWrap[0].style.height=navHeight+"px";
window.addEventListener("resize",()=>{
    const navs=document.getElementsByTagName("nav");
    const navHeight=navs[0].offsetHeight;
   if(navWrap[0].offsetHeight !=navHeight){
       navWrap[0].style.height=navHeight+"px";

   }
});
